<template>
  <div
    class="header-main"
    :style="{ paddingTop: fixedPaddingTop }"
    :class="{ toggled: sidebarActive, 'is-disabled': isDisabled }"
  >
    <div class="header-wrapper">
      <slot name="cookiebanner"></slot>
      <slot name="navbar"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'headernavigation',
  data() {
    return {
      smallScreen:
        (window.ScreenSizeHandler && window.ScreenSizeHandler.getMqForSize('small').selected) ||
        true,
      sidebarActive: false,
      isDisabled: false,
      fixedPaddingTop: '50px',
      currentViewport: null,
    };
  },
  mounted() {
    // NOSONAR
    document.querySelector('.header').style.visibility = 'visible';
    this.currentViewport = window.innerWidth || 0;
    this.adjustVisibility();
    window.addEventListener('resize', () => {
      this.currentViewport = window.innerWidth;
      this.adjustVisibility();
      // re-set the flag to prevent blocking scroll by forgetting to remove `.no-scroll` from `body`
      this.smallScreen =
        window.ScreenSizeHandler && window.ScreenSizeHandler.getMqForSize('small').selected;
    });
    if (window.eventBus) {
      /* istanbul ignore next */
      window.eventBus.$on('sidebar.toggled', (value) => {
        this.handelVisiblity(value);
        this.sidebarActive = value;

        if (this.smallScreen) {
          this.bodyNoScroll(value);
        } else {
          this.bodyNoScroll(false);
        }
      });

      /* istanbul ignore next */
      window.eventBus.$on('sidebarFilter.toggled', (value) => {
        this.isDisabled = value;

        if (this.smallScreen) {
          this.bodyNoScroll(value);
        } else {
          this.bodyNoScroll(false);
        }
      });

      /* istanbul ignore next */
      window.eventBus.$on('headerHeight.updated', () => {
        this.calcHeight();
      });

      /* istanbul ignore next */
      window.eventBus.$on('cookie.gone', () => {
        this.cookieGone();
      });
    }

    /* istanbul ignore next */
    window.addEventListener(
      'orientationchange',
      () => {
        document.querySelector('body').classList.remove('no-scroll');
        if (window.eventBus) {
          window.eventBus.$emit('sidebar.toggled', false);
          window.eventBus.$emit('update.itemnavigation', false);
          window.eventBus.$emit('update.itemmegamenu', false);
        }
      },
      false,
    );

    this.calcHeight();

    /* istanbul ignore next */
    if (window.eventBus) {
      window.eventBus.$on('mediaquery.changed', () => {
        this.calcHeight();
        this.smallScreen =
          window.ScreenSizeHandler && window.ScreenSizeHandler.getMqForSize('small').selected;
        if (window.ScreenSizeHandler.getMqForSize('large').selected !== true) {
          window.eventBus.$emit('sidebar.toggled', false);
          window.eventBus.$emit('update.itemnavigation', false);
          window.eventBus.$emit('update.itemmegamenu', false);
        } else {
          this.bodyNoScroll(false);
          window.eventBus.$emit('sidebar.toggled', true);
        }
      });
    }
  },
  methods: {
    bodyNoScroll(noScroll) {
      if (noScroll) {
        document.querySelector('body').classList.add('no-scroll');
      } else {
        document.querySelector('body').classList.remove('no-scroll');
      }
    },
    calcHeight() {
      /* istanbul ignore next */
      if (document.querySelector('.nav-bar')) {
        this.navbarHeight = document.querySelector('.nav-bar').getBoundingClientRect().height;
      } else {
        this.navbarHeight = 0;
      }

      if (document.querySelector('.cookie-banner')) {
        this.cookieHeight = 52;
      } else {
        this.cookieHeight = 0;
      }

      this.fixedPaddingTop = `${this.navbarHeight + this.cookieHeight}px`;
      return this.fixedPaddingTop;
    },
    cookieGone() {
      if (document.querySelector('.nav-bar')) {
        this.navbarHeight = document.querySelector('.nav-bar').getBoundingClientRect().height;
      } else {
        this.navbarHeight = 0;
      }

      this.fixedPaddingTop = `${this.navbarHeight}px`;
      return this.fixedPaddingTop;
    },
    handelVisiblity(value) {
      if (value) {
        document.querySelector('#nav-sidebar-wrapper').style.visibility = 'visible';
      } else {
        document.querySelector('#nav-sidebar-wrapper').style.visibility = 'hidden';
      }
    },
    adjustVisibility() {
      const isiPad = /iPad/i.test(navigator.userAgent);
      if (isiPad || (this.currentViewport >= 768 && this.currentViewport < 1024)) {
        this.handelVisiblity(false);
      } else {
        this.handelVisiblity(true);
      }
    },
  },
};
</script>
